import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { interrompiSvilTer } from "../../../networking";

const LoadingProgressModal = (props: {
  submitRecurringFetchCall: boolean;
  idSessioneReference: string;
  handleLoadingRecurringData: Function;
  abortControllerRef: React.MutableRefObject<AbortController | null>;
}) => {

  const handleAbortSviluppoTerapiaSubmit = async () => {
    console.log("Interrompendo", props.idSessioneReference);
    props.abortControllerRef.current?.abort();
    try {
      await interrompiSvilTer({
        idSessione: String(props.idSessioneReference),
      }).then((response: any) => {
        console.log(response);
      });
    } catch (error) {
      console.error(
        "Non è stato possibile comunicare al backend lo sviluppo di un piano"
      );
    } finally {
      await props.handleLoadingRecurringData();
    }
  };

  return (
    <>
      <Modal open={props.submitRecurringFetchCall}>
        <Grid
          container
          direction={"column"}
          gap={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            minWidth: "20rem",
            maxWidth: "25rem",
            bgcolor: "background.paper",
            boxShadow: 24,
            outline: "none",
            borderRadius: 2,
            p: 2,
            alignItems: "center",
          }}
        >
          <Grid item xl={12}>
            <Typography sx={{ color: " #024E88", fontWeight: 600 }}>
              Sto Cercando..
            </Typography>
          </Grid>
          <Grid item xl={12}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress size={"6rem"} />
            </Box>
          </Grid>
          <Grid item xl={12} gap={2}>
            <Button
              variant={"containedError"}
              onClick={() => handleAbortSviluppoTerapiaSubmit()}
            >
              Uscita
            </Button>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default LoadingProgressModal;
